var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.064,
    height: 23.998,
    viewBox: "0 0 24.064 23.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55919",
    "data-name": "Group 55919",
    transform: "translate(-360.021 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification_3_",
    "data-name": "notification (3)",
    transform: "translate(360.021 50.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55670",
    "data-name": "Group 55670",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85526",
    "data-name": "Path 85526",
    d: "M39.539,17.866a2.77,2.77,0,0,0-2.769-2.438.3.3,0,0,1-.3-.3V10.58a7.951,7.951,0,0,0-5.134-7.417,2.7,2.7,0,0,0,.054-.528,2.634,2.634,0,1,0-5.269,0,2.821,2.821,0,0,0,.05.513,7.708,7.708,0,0,0-5.13,7.267v4.709a.305.305,0,0,1-.3.3,2.767,2.767,0,0,0-2.769,2.438,2.7,2.7,0,0,0,2.688,2.962H25.3a3.47,3.47,0,0,0,6.9,0H36.85a2.7,2.7,0,0,0,2.688-2.962ZM28.75,1.543a1.093,1.093,0,0,1,1.092,1.092.943.943,0,0,1-.015.147,6.835,6.835,0,0,0-.795-.073,7.948,7.948,0,0,0-1.358.077.943.943,0,0,1-.015-.147,1.094,1.094,0,0,1,1.092-1.1Zm0,20.828a1.935,1.935,0,0,1-1.89-1.543h3.78A1.935,1.935,0,0,1,28.75,22.371Zm8.956-3.464a1.148,1.148,0,0,1-.856.378H20.65a1.148,1.148,0,0,1-.856-.378,1.133,1.133,0,0,1-.293-.895,1.212,1.212,0,0,1,1.234-1.041,1.85,1.85,0,0,0,1.848-1.848V10.414A6.174,6.174,0,0,1,28.75,4.243c.077,0,.15,0,.228,0a6.31,6.31,0,0,1,5.944,6.333v4.544a1.85,1.85,0,0,0,1.848,1.848A1.212,1.212,0,0,1,38,18.013,1.155,1.155,0,0,1,37.706,18.907Z",
    transform: "translate(-17.95 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85527",
    "data-name": "Path 85527",
    d: "M19.29,50.968a.77.77,0,0,0,.752-.606A9.017,9.017,0,0,1,22.5,45.9.772.772,0,0,0,21.4,44.808a10.554,10.554,0,0,0-2.87,5.226.767.767,0,0,0,.586.918A.893.893,0,0,0,19.29,50.968Z",
    transform: "translate(-18.479 -41.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85528",
    "data-name": "Path 85528",
    d: "M290.835,50.911a.813.813,0,0,0,.166-.019.768.768,0,0,0,.586-.918,10.571,10.571,0,0,0-2.87-5.226.772.772,0,0,0-1.092,1.092,9.047,9.047,0,0,1,2.453,4.463A.777.777,0,0,0,290.835,50.911Z",
    transform: "translate(-270.044 -41.654)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_719",
    "data-name": "Ellipse 719",
    cx: 6.484,
    cy: 6.484,
    r: 6.484,
    transform: "translate(371.117 50)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(377.601 58.985)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Comfortaa-Medium, Comfortaa",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2,
    y: 0
  }, "2")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b473c69b7e2d6ead028ef352722cb628.svg";
export { ForwardRef as ReactComponent };